import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityEntidadesProductivaAddFailure,
  entityEntidadesProductivaAddRequest,
  entityEntidadesProductivaAddSuccess,
  entityEntidadesProductivaChangeFailure,
  entityEntidadesProductivaChangeRequest,
  entityEntidadesProductivaChangeSuccess,
  entityEntidadesProductivaLoadFailure,
  entityEntidadesProductivaLoadRequest,
  entityEntidadesProductivaLoadSuccess
} from './entity-entidades-productiva.actions';

import { EntidadesProductivaService } from './entity-entidades-productiva.service';
import {
  entityPersonasJuridicaAddSuccess,
  entityPersonasJuridicaChangeSuccess
} from '../entity-personas-juridica/entity-personas-juridica.actions';
import {
  entityPersonasFisicaAddSuccess,
  entityPersonasFisicaChangeSuccess
} from '../entity-personas-fisica/entity-personas-fisica.actions';
import { EntidadesProductiva } from './entity-entidades-productiva.model';
import { Update } from '@ngrx/entity';

@Injectable()
export class EntidadesProductivaEffects {
  // load
  loadRequestEntidadesProductiva = createEffect(() =>
    this.actions$.pipe(
      ofType(
        entityEntidadesProductivaLoadRequest,
        entityPersonasJuridicaAddSuccess,
        entityPersonasFisicaAddSuccess,
        entityPersonasJuridicaChangeSuccess,
        entityPersonasFisicaChangeSuccess
        //entityEntidadesProductivaChangeRequest
      ),
      mergeMap(() =>
        this.entidadesProductivaService.getEntidadesProductiva().pipe(
          map((items) => entityEntidadesProductivaLoadSuccess({ items })),
          catchError((error) =>
            of(entityEntidadesProductivaLoadFailure({ error }))
          )
        )
      )
    )
  );

  // add
  addRequestEntidadesProductiva = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEntidadesProductivaAddRequest),
      switchMap((action) =>
        this.entidadesProductivaService.addEntidadProductiva(action.item).pipe(
          map((item) => entityEntidadesProductivaAddSuccess({ item })),
          catchError((error) =>
            of(entityEntidadesProductivaAddFailure({ error }))
          )
        )
      )
    )
  );

  addSuccessEntidadesProductivaRegistro = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasJuridicaAddSuccess, entityPersonasFisicaAddSuccess),
      map((action) =>
        entityEntidadesProductivaAddSuccess({
          item: action.item.entidad_productiva
        })
      )
    )
  );

  // change
  changeRequestEntidadesProductiva = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEntidadesProductivaChangeRequest),
      switchMap((action) =>
        this.entidadesProductivaService
          .changeEntidadProductiva(action.item)
          .pipe(
            map((item) => {
              return entityEntidadesProductivaChangeSuccess({
                item: {
                  ...item,
                  estado: item.estado,
                  exclusivo_comercializacion: item.exclusivo_comercializacion
                }
              });
            }),
            catchError((error) =>
              of(entityEntidadesProductivaChangeFailure({ error }))
            )
          )
      )
    )
  );

  changeSuccessEntidadesProductivaRegistro = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityEntidadesProductivaChangeSuccess),
        tap((action) => {
          // Fin del tramite
          /*if (action.item.changes.estado == 2) {
            this.router.navigateByUrl('/tramite/vista-tramites');
          }*/
        })
      ),
    { dispatch: false }
  );

  // persona juridica

  entidadesProductivaChangeSuccessByPersonaJuridicaSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasJuridicaChangeSuccess),
      map((result) => {
        return entityEntidadesProductivaChangeSuccess({
          item: result.item.entidadProductiva
        });
      })
    )
  );

  // persona fisica

  entidadesProductivaChangeSuccessByPersonaFisicaSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasFisicaChangeSuccess),
      map((result) => {
        return entityEntidadesProductivaChangeSuccess({
          item: result.item.entidadProductiva
        });
      })
    )
  );

  // delete

  constructor(
    private actions$: Actions,
    private entidadesProductivaService: EntidadesProductivaService,
    private router: Router
  ) {
    this.entidadesProductivaService.url = environment.apiUrl;
  }
}
